import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getRailwayLineList(params) {
  return request({
    url: URL.mdm.basicData.railwayLine,
    method: 'get',
    params
  })
}

export function saveRailwayLine(data) {
  return request({
    url: URL.mdm.basicData.railwayLine,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delRailwayLine(uuid) {
  return request({
    url: URL.mdm.basicData.railwayLine + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

